import { __require as f } from "./_baseFindIndex.js";
import { __require as d } from "./_baseIsNaN.js";
import { __require as q } from "./_strictIndexOf.js";
var r, n;
function x() {
  if (n) return r;
  n = 1;
  var a = f(), _ = d(), t = q();
  function u(i, e, s) {
    return e === e ? t(i, e, s) : a(i, _, s);
  }
  return r = u, r;
}
export {
  x as __require
};
